<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/chats"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ otherName }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo" class="ion-padding" (ionScroll)="onScroll()" scrollEvents="true" #content>
  <div class="older-btn" *ngIf="hasMoreOlder">
    <ion-button size="small" fill="clear" (click)="loadOlder()" [disabled]="isLoadingOlder">
      {{ isLoadingOlder ? 'Loading…' : 'Load older messages' }}
    </ion-button>
  </div>
  <div class="messages">
    <div class="row" *ngFor="let m of messages; trackBy: trackById" [class.mine]="isMine(m)">
      <div class="bubble">
        <ng-container [ngSwitch]="m.kind">
          <div *ngSwitchCase="'text'">
            <div class="text">{{ m.text }}</div>
          </div>
          <div *ngSwitchCase="'image'" (click)="openImage(m)"> <img class="image-msg" [src]="getMediaUrl(m)"
              [style.max-width.px]="120" [style.max-height.px]="120" loading="lazy" />
          </div>
          <div *ngSwitchCase="'voice'" class="voice">
            <button class="icon" (click)="togglePlay(m)">
              <ion-icon [name]="isPlaying(m) ? 'pause' : 'play'"></ion-icon>
            </button>

            <audio #player [src]="getMediaUrl(m)" preload="metadata" (ended)="onEnded(m)"
              (timeupdate)="onTime(m, player.currentTime)" (loadedmetadata)="onLoadedMetadata(m, player)">
            </audio>

            <div class="waveform">
              <div class="progress-bar" (click)="seek(m, player, $event)">
                <div class="progress" [style.width.%]="getProgress(m, player)">
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <div class="time" *ngIf="m.kind==='voice'">
          {{ renderTime(currentTime[m.id] || 0) }} / {{ renderTime((m.media.durationMs || 0) / 1000) }}
        </div>
        <div class="meta">{{ time(m.createdAt) }}</div>
      </div>
    </div>
    <div class="uploading-container" *ngIf="threadVoiceUploadCount()>0 || threadImageUploadCount() >0">
      <div class="chat-bubble uploading" *ngIf="threadImageUploadCount() >0">
        <div class="media-placeholder">
          <div class="spinner"></div>
        </div>
        <div class="upload-text">Uploading...</div>
      </div>
      <!-- chat-message-uploading-voice.component.html -->
      <div class="chat-bubble uploading voice-uploading" *ngIf="threadVoiceUploadCount()>0">
        <div class="voice-placeholder">
          <div class="sound-wave">
            <span></span><span></span><span></span><span></span><span></span>
          </div>
        </div>
        <div class="upload-text">Uploading...</div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar class="composer">
    <ion-buttons slot="start">
      <ion-button slot="start" (click)="pickImage()" fill="clear" [disabled]="newMessage?.trim().length>0"><ion-icon
          name="image-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>

    <ion-textarea [(ngModel)]="newMessage" placeholder="Type a message…" [autoGrow]="true" maxlength="4096" rows="1"
      (keydown)="onKeydown($event)" [disabled]="recState==='rec'">
    </ion-textarea>
    <ion-buttons slot="end">
      <ion-button slot="start" (click)="startRec()" *ngIf="recState!=='rec'"
        [disabled]="newMessage?.trim().length>0"><ion-icon slot="icon-only" name="mic-outline"></ion-icon></ion-button>
      <ion-button slot="start" (click)="deleteRec()" *ngIf="recState==='rec'"><ion-icon slot="icon-only"
          name="trash-outline"></ion-icon></ion-button>
      <ion-button slot="start" (click)="stopRec()" *ngIf="recState==='rec'"><ion-icon slot="icon-only"
          name="paper-plane-outline"></ion-icon></ion-button>
      <ion-button slot="end" (click)="send()" *ngIf="recState!=='rec'" [disabled]="!newMessage?.trim()"><ion-icon
          slot="icon-only" name="paper-plane-outline"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>

<app-image-picker style="display: none;" (photoCaptured)="onPhotoCaptured($event)"></app-image-picker>